import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    UserGroupIcon,
    UsersIcon,
    AcademicCapIcon,
    BuildingOfficeIcon,
    CogIcon,
    BriefcaseIcon,
    CalendarDaysIcon,
    ArrowPathIcon,
    ArrowDownTrayIcon,
    BanknotesIcon,
    ClipboardDocumentListIcon
} from '@heroicons/react/24/outline';
import { ShareIcon } from '@heroicons/react/24/solid';

const menuItems = [
    {
        name: 'Tipos de Recurso',
        href: '/admin/resource-types',
        icon: UserGroupIcon
    },
    {
        name: 'Usuários',
        href: '/admin/users',
        icon: UsersIcon
    },
    {
        name: 'Senioridades',
        href: '/admin/seniorities',
        icon: AcademicCapIcon
    },
    {
        name: 'Cargos',
        href: '/admin/positions',
        icon: BriefcaseIcon
    },
    {
        name: 'Parâmetros de Avaliação',
        href: '/admin/evaluation-thresholds',
        icon: ClipboardDocumentListIcon
    },
    {
        name: 'Clientes',
        href: '/admin/clients',
        icon: BuildingOfficeIcon
    },
    {
        name: 'Projetos',
        href: '/admin/projects',
        icon: CogIcon
    },
    {
        name: 'Departamentos',
        href: '/admin/departments',
        icon: ShareIcon
    },
    {
        name: 'Janelas de Atualização',
        href: '/admin/update-windows',
        icon: CalendarDaysIcon
    },
    {
        name: 'Migrações',
        href: '/admin/migrations',
        icon: ArrowPathIcon
    },
    {
        name: 'Exportações',
        href: '/admin/exports',
        icon: ArrowDownTrayIcon
    },
    {
        name: 'Configurações da Empresa',
        href: '/admin/company-settings',
        icon: BanknotesIcon
    },

];

export default function AdminMenu() {
    const location = useLocation();

    return (
        <div className="space-y-1">
            <div className="px-3 py-2">
                <h2 className="mb-2 px-4 text-lg font-semibold tracking-tight">
                    Administração
                </h2>
                <div className="space-y-1">
                    {menuItems.map((item) => {
                        const isActive = location.pathname === item.href;
                        return (
                            <Link
                                key={item.href}
                                to={item.href}
                                className={`flex items-center px-4 py-2 text-sm font-medium rounded-md ${isActive
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                    }`}
                            >
                                <item.icon className="mr-3 h-5 w-5" />
                                {item.name}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
} 
